import { useTheme } from 'styled-components';
import { Button } from '../../ui/Button/Button';
import { ThemeType } from '../../../theme/themeType';
import S from './ActionOnGroupModalStyles';
import useGetVehiclesByGroupById from '../../../API/hooks/groups/useGetVehiclesByGroupById';

type Props = {
  title: string;
  entity: 'vehicle' | 'user';
  action: 'add' | 'delete';
  groupId?: string;
  fleetId?: string;
  onClose: () => void;
  onAction: any;
};

function ActionOnGroupModal({
  title, entity, action, groupId, fleetId, onClose, onAction,
}: Props): JSX.Element {
  const theme = useTheme() as ThemeType;
  const { data: vehiclesFromGroup, isLoading, isError } = useGetVehiclesByGroupById(groupId || '', fleetId || '', '', entity === 'vehicle' && action === 'delete');
  return (
    <S.Wrapper>
      <div className="title">
        {title}
      </div>
      {entity === 'vehicle' && action === 'delete' && (
        <div className="sub-title">
          {isLoading ? 'checking a group...' : ''}
          {!isLoading && !isError && vehiclesFromGroup?.results?.length === 1 ? 'Attention! Removing of last vehicle from group will cause removing of whole group!' : ''}
        </div>
      )}
      <div className="actions">
        <Button
          className="button"
          padding="7px 40px"
          onClick={onClose}
        >Cancel
        </Button>
        <Button
          className="button"
          padding="7px 40px"
          onClick={() => onAction(vehiclesFromGroup?.results?.length)}
          textColor={action === 'delete' ? theme.colors.text : theme.colors.black}
          background={action === 'delete' ? theme.colors.red : theme.colors.main_cta}
          disabled={entity === 'vehicle' && action === 'delete' && isLoading}
        >{action === 'delete' ? 'Remove' : 'Add'}
        </Button>
      </div>
    </S.Wrapper>
  );
}

export default ActionOnGroupModal;
